import { render, staticRenderFns } from "./modal-crop-photo.vue?vue&type=template&id=1f42f5bc"
import script from "./modal-crop-photo.vue?vue&type=script&lang=js"
export * from "./modal-crop-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports